import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div
      className="tabing_section healthcare_tabs_sec cloud_computing_tabs p-100"
      style={{ background: "#f9f9f9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Our Comprehensive ML Development Toolchain
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Leverage our expert ML development services for seamless data
              integration, efficient model deployment, and insightful analytics
              to drive business growth and operational excellence.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Cloud">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/cloud/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/cloud/Azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/cloud/Google_Cloud_Platform.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud Platform</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Data Annotation & Labeling">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-annotation/Labelbox.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Labelbox</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-annotation/Supervisely.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Supervisely</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-annotation/Amazon_SageMaker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Amazon SageMaker</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Data Processing & Preparation">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-processing/Apache_Spark.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Apache Spark</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-processing/Dask.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Dask</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-processing/flink-squirrel.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Flink Squirrel</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-processing/pandas.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Pandas</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Data Storage">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-storage/Amazon-S3.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Amazon-S3</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-storage/cassandra.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Cassandra</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-storage/datalake.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Datalake</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-storage/google-bigquery.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Google BigQuery</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-storage/Mongodb.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-storage/Mysql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Mysql</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/data-storage/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="DevOps">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/devops/Docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/devops/Git.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Git</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/devops/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/devops/Kubernetes.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Kubernetes</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/devops/Terraform.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Terraform</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="ML Libraries">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/ml-library/Keras.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Keras</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/ml-library/LightGBM.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>LightGBM</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/ml-library/pytorch.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Pytorch</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/ml-library/Scikit-learn.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Scikit Learn</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/ml-library/TensorFlow.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Tensor Flow</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/ml-library/XGBoost.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>XGBoost</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="7" title="Monitoring Tools">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/monitoring/MLflow.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>MLflow</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/monitoring/Neptune-ai.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Neptune ai</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/monitoring/TensorBoard.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Tensor Board</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/monitoring/Weights_Biases.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Weights & Biases</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="8" title="Visualization Tools">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/visualization-tools/Grafana.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Grafana</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/visualization-tools/Matplotlib.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Matplotlib</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/visualization-tools/Plotly.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Plotly</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/visualization-tools/Power_BI.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Power BI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/visualization-tools/Tableau.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Tableau</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
